import { debounce } from '../core/helpers';

const openCloseAccordion = (item, breakpoint) => {
  try {
    let current_breakpoint = window.theme.breakpoints.current;
    const accordion = item.closest('.accordion');

    if (current_breakpoint !== 'mobile') {
      current_breakpoint = 'desktop';
    }

    if (!accordion.querySelector(`[data-${breakpoint}-accordion]`) || current_breakpoint !== breakpoint) {
      return false;
    }

    let is_active = item.classList.contains('active');
    const is_active_on_load = item.classList.contains('active-on-load');
    const content = item.querySelector('[data-accordion-content]');
  
    accordion.querySelectorAll(`[data-${breakpoint}-accordion]`).forEach(el => {
      el.classList.remove('active', 'active-on-load');
    });
  
    if (is_active_on_load) {
      is_active = false;
    }
  
    if (!is_active) {
      item.classList.add('active');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }
  
    accordion.querySelectorAll(`[data-${breakpoint}-accordion]:not(.active) [data-accordion-content]`).forEach(el => {
      el.style.maxHeight = 0;
    });
  
    // [ADA] Update aria attributes for all items
    accordion.querySelectorAll(`[data-${breakpoint}-accordion]`).forEach(accordionItem => {
      const accordionTitle = accordionItem.querySelector('[data-accordion-title]');
      const accordionContent = accordionItem.querySelector('[data-accordion-content]');
      const isActive = accordionItem.classList.contains('active');
    
      if (accordionTitle) {
        accordionTitle.setAttribute('aria-expanded', isActive);
        accordionTitle.setAttribute('role', 'button');
      }
      if (accordionContent) {
        accordionContent.setAttribute('aria-hidden', !isActive);
        accordionContent.setAttribute('role', 'region');
        if (accordionTitle) {
          accordionContent.setAttribute('aria-labelledby', accordionTitle.id);
        }
      }
    });

    window.dispatchEvent(new Event('resize'));
  } catch (e) {
    console.log(e);
  }

  return true;
};

/*
const resetAccordion = (accordion_item = '') => {
  const parent_element = (accordion_item === '') ? '' : `${accordion_item} `;

  if (window.theme.breakpoints.current === 'mobile') {
    $(`${parent_element}[data-desktop-accordion]`).removeClass('active');
    $(`${parent_element}[data-desktop-accordion] [data-accordion-content]`).removeAttr('style');
    if ($(`${accordion_item}.has-accordion .accordion [data-mobile-accordion]`).length) {
      $(`${accordion_item}.has-accordion .accordion [data-mobile-accordion]`).first().addClass('active-on-load');
    }
    if ($(`${accordion_item}.has-accordion .accordion [data-desktop-accordion]`).length) {
      $(`${accordion_item}.has-accordion .accordion [data-desktop-accordion]`).first().addClass('active-on-load');
    }
    if ($(`${parent_element}[data-mobile-accordion].active-on-load`).length) {
      $(`${parent_element}[data-mobile-accordion].active-on-load`).trigger('click');
    }
  } else {
    $(`${parent_element}[data-mobile-accordion]`).removeClass('active');
    $(`${parent_element}[data-mobile-accordion] [data-accordion-content]`).removeAttr('style');
    $(`${parent_element}.has-accordion .accordion [data-mobile-accordion]`).first().addClass('active-on-load');
    $(`${parent_element}.has-accordion .accordion [data-desktop-accordion]`).first().addClass('active-on-load');
    $(`${parent_element}[data-desktop-accordion].active-on-load`).trigger('click');
  }
};
*/

// Content height can change when resizing the browser
const updateActiveHeight = (accordion_item = '') => {
  const parent_element = accordion_item ? document.querySelector(accordion_item) : document;
  const active_item = parent_element.querySelector('.active');
  if (!active_item) return;
  const content = active_item.querySelector('[data-accordion-content]');
  if (content) content.style.maxHeight = content.scrollHeight + 'px';
};

const initAccordion = (accordion_item = '') => {
  const parent_element = accordion_item ? document.querySelector(accordion_item) : document;

  // [ADA]
  parent_element.querySelectorAll('[data-desktop-accordion] [data-accordion-content]').forEach(el => {
    el.setAttribute('tabindex', 0);
  });

  // Mobile click/touch
  parent_element.querySelectorAll('.has-accordion .accordion [data-mobile-accordion] [data-accordion-title]').forEach(el => {
    el.addEventListener('click', (e) => {
      if (window.theme.breakpoints.current !== 'mobile') return;
      e.preventDefault();
      e.stopPropagation();
      openCloseAccordion(el.parentElement, 'mobile');
    });
  });

  // Desktop click
  parent_element.querySelectorAll('.has-accordion .accordion [data-desktop-accordion] [data-accordion-title]').forEach(el => {
    el.addEventListener('click', (e) => {
      if (window.theme.breakpoints.current === 'mobile') return;
      e.preventDefault();
      e.stopPropagation();
      openCloseAccordion(el.parentElement, 'desktop');
    });
    el.addEventListener('keydown', (e) => {
      if (window.theme.breakpoints.current === 'mobile') return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
      openCloseAccordion(el.parentElement, 'desktop');
    });
  });

  window.addEventListener('resize', debounce(() => {
    updateActiveHeight(accordion_item);
  }, 100));

  // Open the "Active on Load" item(s) if defined
  parent_element.querySelectorAll('.accordion__item.active-on-load [data-accordion-title]').forEach(el => {
    el.click();
  });
};

export {
  initAccordion,
  // resetAccordion,
};
